module.exports = __webpack_public_path__ + "static/media/aspen_logo_black@2x.0254682a.svg";